import React, { useEffect, useState } from 'react';
import { Bars3Icon, MoonIcon, SunIcon, ArrowRightStartOnRectangleIcon } from '@heroicons/react/24/outline';

export default function Header({ onOpenSidebar }: { onOpenSidebar: () => void }) {
  const [isDark, setIsDark] = useState(false);
  const from = localStorage.getItem('from');
  // Appliquer le thème au chargement + écouter les changements système
  useEffect(() => {
    const mq = window.matchMedia('(prefers-color-scheme: dark)');
    const stored = localStorage.getItem('theme');
    

    const initialDark = stored ? stored === 'dark' : mq.matches;
    setIsDark(initialDark);
    document.documentElement.classList.toggle('dark', initialDark);

    const handleChange = (e: MediaQueryListEvent) => {
      // ne change le thème que si l'utilisateur n'a pas forcé un choix
      if (!stored) {
        setIsDark(e.matches);
        document.documentElement.classList.toggle('dark', e.matches);
      }
    };
    mq.addEventListener('change', handleChange);
    return () => mq.removeEventListener('change', handleChange);
  }, []);

  const toggleTheme = () => {
    const next = !isDark;
    setIsDark(next);
    document.documentElement.classList.toggle('dark', next);
    localStorage.setItem('theme', next ? 'dark' : 'light');
  };

  const logout = () => {
    localStorage.removeItem('loginCode');
    window.location.href = window.location.origin;
  };

  return (
    <header
      className="
            fixed top-0 lg:fixed lg:left-64
            w-full lg:w-[calc(100%-16rem)]
            z-[40]
            bg-white/90 dark:bg-darkMode
            backdrop-blur supports-[backdrop-filter]:backdrop-blur
            border-b border-gray-200 dark:border-gray-700
            px-4 py-3 flex items-center justify-between
                
      "
    >
      <button className="lg:hidden text-gray-600 dark:text-white" onClick={onOpenSidebar}>
        <Bars3Icon className="w-6 h-6" />
      </button>

      <h1 className="text-xl font-semibold text-gray-800 dark:text-white">Dashboard</h1>

      <div className="flex items-center gap-4">
        <button
          onClick={toggleTheme}
          className="text-gray-600 dark:text-white"
          title="Changer le thème"
        >
          {isDark ? (
            <SunIcon className="w-6 h-6" />
          ) : (
            <MoonIcon className="w-6 h-6" />
          )}
        </button>

        {from != "ALIZEE" && (
            <button
              onClick={logout}
              className="
                flex items-center gap-2
                text-gray-600 dark:text-white
                hover:text-red-600 dark:hover:text-red-400
                transition-colors
              "
              title="Déconnexion"
            >
              <ArrowRightStartOnRectangleIcon className="w-6 h-6" />
              <span className="hidden sm:inline">Déconnexion</span>
            </button>
          )}
        </div>
    </header>
  );
}
